import { IPillProps } from './types'
import styles from './styles.module.scss'
import clsx from 'clsx'

const Pill = ({
  children,
  color = 'navy',
  id,
  size = 'sm',
  style,
  variant = 'default',
  ...props
}: IPillProps) => {
  return (
    <div
      className={clsx('mui-pill', styles.pill, styles[variant], styles[size], styles[color])}
      data-testid="mui-pill"
      id={id}
      style={{ ...style }}
      {...props}
    >
      <span className={styles.children}>{children}</span>
    </div>
  )
}

export default Pill
